import PerspectiveCarousel from '@/component/Primitive/PerspectiveCarousel'
import Prose from '@/component/Primitive/Prose'
import React from 'react'
import { string, array } from 'prop-types'
import styles from './AboutBrand.module.scss'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'

const AboutBrand = ({ description, logo, items }) => {
  return (
    <div className={styles.AboutBrand}>
      <Container center gutter size="large">
        <div className={styles.AboutBrandInner}>
          <div className={styles.Content}>
            <Stack gap="small">
              <Type
                themed
                as="h1"
                size={['heading3', 'heading0']}
                weight="medium"
                className={styles.Title}
              >
                About
              </Type>
              <img className={styles.Logo} src={logo} alt="Logo" />
              <Prose
                className={styles.Description}
                dangerousHtml={description}
              />
            </Stack>
          </div>
          <div className={styles.Carousel}>
            <PerspectiveCarousel items={items} />
          </div>
        </div>
      </Container>
    </div>
  )
}

AboutBrand.propTypes = {
  description: string,
  logo: string,
  items: array
}

export default AboutBrand
